import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    @Input() title: string;
    @Input() template: TemplateRef<any>;
    public bottom = '0px';
    ngOnInit() {
        // window.addEventListener("scroll", () => {
        //     const operationBar = document.getElementById('opration-bar-id');
        //     const footer = document.getElementById('back-office-footer-id');
        //     const delta = 198;//operationBar ? 198 - operationBar.offsetHeight - footer.offsetHeight : 198 - footer.offsetHeight;
        //     const id = operationBar ? 'opration-bar-id' : 'back-office-footer-id';
        //     const bottomH = document.getElementById(id).offsetTop - delta - (window.scrollY + document.getElementById('side-bar-id').offsetHeight) -35;
        //     if (bottomH < 0) {
        //         this.bottom = `${Math.abs(bottomH)} px`;
        //     }
        //     else this.bottom = '0px';
        // });
    }
    getBottom() {
        return this.bottom;
    }
}
